import { t, tf } from "./i18n.js";
// ---------------------------------------------------------------------------
// OBS-Anbindung: Szenenwechsel bei Checkout-Situationen (14.08.2026)
//
// WAS DAS IST
// Wer streamt, laesst OBS auf demselben Rechner laufen. OBS (ab v28)
// bringt einen WebSocket-Server mit (Tools > WebSocket Server Settings,
// Standardport 4455). Diese Datei verbindet die Web-App damit und
// schaltet auf eine "Checkout-Szene" (z. B. Board-Zoom), sobald ein
// Spieler im 501 auf einem ausmachbaren Rest steht - und zurueck auf die
// Standardszene, wenn nicht.
//
// WARUM DAS AUS DEM BROWSER FUNKTIONIERT
// Dieselbe Begruendung wie beim Tracker (autoscore.js, TRACKER_URL):
// ws:// zu 127.0.0.1 gilt im Browser als vertrauenswuerdiger Loopback
// und ist auch aus der HTTPS-Seite erlaubt. Die Passwort-Authentifi-
// zierung von obs-websocket (v5, Challenge/Response mit SHA-256) macht
// die Bibliothek obs-websocket-js selbst; sie braucht crypto.subtle und
// damit einen Secure Context - HTTPS bzw. localhost erfuellen das.
//
// HALTUNG (dieselbe wie beim Tracker)
// OBS ist Zusatznutzen, kein Fundament: Kein OBS -> stiller Verzicht,
// kein Fehlerbanner, keine Dauerschleife. Ein Szenenwechsel darf NIE
// die Wertung beruehren - diese Datei liest nur den Punktestand aus dem
// DOM und redet mit OBS, sonst mit niemandem.
//
// ZUSTANDSQUELLE: POLLING STATT EREIGNIS
// Der Rest des Werfers wird an einem guten Dutzend Stellen gesetzt
// (Ziffernblock, Board, Rechner, Auto-Scoring, Online-Sync, Undo ...).
// Ueberall einen Aufruf einzubauen hiesse, jede kuenftige Stelle zu
// vergessen. Stattdessen liest ein 500-ms-Takt die beiden Punktefelder
// (#p1-score/#p2-score) - dieselbe "eine Quelle, zweite Anzeige"-Idee
// wie spiegelRest in board-input.js, nur gepollt statt beobachtet, weil
// die Felder beim Laden noch nicht existieren (Partials) und ein
// Beobachter je Feld hier nichts einspart. Zwei DOM-Reads pro halbe
// Sekunde kosten nichts; gesendet wird nur bei Szenen-AENDERUNG.
//
// BEREICHS-SZENEN (14.08.2026)
// Ein Zoom aufs ganze Board ist beim Checkout schon besser als nichts -
// spannend ist aber die eine Stelle, an der das Doppel sitzt. Deshalb
// kann der Streamer fuenf Szenen hinterlegen (oben, rechts, unten,
// links, Mitte) und die App waehlt die, in der das Zieldoppel liegt.
// Woher der Bereich kommt: dartboard.js (boardBereich) teilt die Scheibe
// in vier Viertel zu je fuenf Sektoren plus Bull - die Grenze liegt bei
// 45 Grad, also zwischen zwei Sektormitten, damit kein Feld auf der
// Kante sitzt.
//
// WANN GEZOOMT WIRD - ZWEI KORREKTUREN (14.08.2026, nach Praxistest)
//
// (1) NUR DER EIGENE REST. Vorher zaehlte der Spieler an der Oche, davor
//     sogar beide. Online ist beides falsch: Der Gegner wirft auf SEIN
//     Board, vor dieser Kamera steht seine Scheibe gar nicht. Der Zoom
//     zeigte dann eine leere Stelle, waehrend anderswo gespielt wird.
//     Wessen Rest gilt, beantwortet game-501.js (eigenerRest501) - dort
//     liegt das Wissen, ob lokal, online oder gegen einen Bot gespielt
//     wird. Ohne diese Auskunft: Standardszene. Ein Zoom auf ein
//     geratenes Doppel waere schlimmer als kein Zoom.
//
// (2) ERST, WENN EIN FELD ANVISIERT WIRD. Vorher genuegte ein
//     ausmachbarer Rest (2-170) - bei 170 zeigte die Mitte-Szene schon
//     das Bull, obwohl zuerst zweimal T20 fallen muss. Jetzt zoomt die
//     App erst, wenn der Rest MIT EINEM DART zu treffen ist:
//     gerade Zahl bis 40 -> das zugehoerige Doppel (Wunsch woertlich:
//     "Rest <= 40 und Rest % 2 === 0"). Ein ungerader Rest oder einer
//     ueber 40 heisst: Der Spieler stellt noch, es gibt kein Ziel.
//
//     MIT AUFGENOMMEN: Rest 50 -> Bullseye. Das ist die einzige
//     Erweiterung der woertlichen Regel und sie ist noetig - 50 ist wie
//     jedes Doppel ein Ein-Dart-Finish, und ohne sie waere die
//     Mitte-Szene nie erreichbar (Bull 25 ist KEIN gueltiges Finish und
//     bleibt draussen).
//
// EINSTELLUNGEN (einstellungen.html, gespeichert in localStorage):
//   enabled, port, password, szeneCheckout, szeneStandard,
//   bereicheAktiv, szeneOben, szeneRechts, szeneUnten, szeneLinks,
//   szeneMitte
// ---------------------------------------------------------------------------

// obs-websocket-js wird DYNAMISCH geladen (unten in verbindeObs): Die
// allermeisten Nutzer streamen nicht - ihr Bundle soll die Bibliothek
// nicht tragen. Vite legt sie durch den dynamischen Import in einen
// eigenen Chunk, der erst beim Einschalten der Anbindung geladen wird.

const OBS_KEY = "secure-darts:obs";
const TAKT_MS = 500;
// Wiederverbindung mit wachsendem Abstand - dieselbe Idee wie beim
// Tracker (autoscore.js WARTEZEITEN_MS), nur kuerzer, weil OBS bewusst
// vom Nutzer gestartet wird.
const OBS_WARTEZEITEN_MS = [2000, 5000, 10000, 30000];

const obsZustand = {
  obs: null, // OBSWebSocket-Instanz
  verbunden: false,
  verbindet: false,
  wiederholIndex: 0,
  wiederholTimer: null,
  taktTimer: null,
  aktuelleSzene: null, // zuletzt GESETZTE Szene (nur unsere Wechsel)
};

// ── Einstellungen ──────────────────────────────────────────────────────────

function obsEinstellungen() {
  const vorgabe = {
    enabled: false,
    port: 4455,
    password: "",
    szeneCheckout: "Checkout",
    szeneStandard: "Standard",
    bereicheAktiv: false,
    szeneOben: "Checkout Oben",
    szeneRechts: "Checkout Rechts",
    szeneUnten: "Checkout Unten",
    szeneLinks: "Checkout Links",
    szeneMitte: "Checkout Mitte",
  };
  try {
    const roh = localStorage.getItem(OBS_KEY);
    return roh ? { ...vorgabe, ...JSON.parse(roh) } : vorgabe;
  } catch (error) {
    return vorgabe;
  }
}

function speichereObsEinstellungen(teil) {
  const neu = { ...obsEinstellungen(), ...teil };
  try {
    localStorage.setItem(OBS_KEY, JSON.stringify(neu));
  } catch (error) {
    // Speicher voll/gesperrt - dann gilt die Einstellung nur bis zum
    // Neuladen; ein Fehlerbanner waere hier lauter als das Problem.
  }
  // Ein-/Ausschalten sofort wirksam machen, ohne Neuladen.
  if (teil.enabled === false) trenneObs();
  starteObsTakt();
  return neu;
}

// ── Verbindung ─────────────────────────────────────────────────────────────

async function verbindeObs() {
  const conf = obsEinstellungen();
  if (!conf.enabled || obsZustand.verbunden || obsZustand.verbindet) return;
  obsZustand.verbindet = true;
  try {
    if (!obsZustand.obs) {
      const { default: OBSWebSocket } = await import("obs-websocket-js");
      obsZustand.obs = new OBSWebSocket();
      obsZustand.obs.on("ConnectionClosed", () => {
        obsZustand.verbunden = false;
        obsZustand.aktuelleSzene = null;
        planeObsWiederverbindung();
      });
    }
    await obsZustand.obs.connect(
      `ws://127.0.0.1:${Number(conf.port) || 4455}`,
      conf.password || undefined,
    );
    obsZustand.verbunden = true;
    obsZustand.wiederholIndex = 0;
    console.info("[obs] verbunden - Szenenwechsel aktiv");
  } catch (error) {
    // Kein OBS, falscher Port, falsches Passwort: leise weiterprobieren.
    obsZustand.verbunden = false;
    planeObsWiederverbindung();
  } finally {
    obsZustand.verbindet = false;
  }
}

function planeObsWiederverbindung() {
  if (!obsEinstellungen().enabled) return;
  const wartezeit =
    OBS_WARTEZEITEN_MS[
      Math.min(obsZustand.wiederholIndex, OBS_WARTEZEITEN_MS.length - 1)
    ];
  obsZustand.wiederholIndex += 1;
  clearTimeout(obsZustand.wiederholTimer);
  obsZustand.wiederholTimer = setTimeout(verbindeObs, wartezeit);
}

function trenneObs() {
  clearTimeout(obsZustand.wiederholTimer);
  obsZustand.wiederholIndex = 0;
  obsZustand.aktuelleSzene = null;
  if (obsZustand.obs && obsZustand.verbunden) {
    obsZustand.obs.disconnect().catch(() => {});
  }
  obsZustand.verbunden = false;
}

// ── Entscheidung: welche Szene gehoert zum Spielstand? ─────────────────────

/** Das Feld, das bei diesem Rest MIT EINEM DART getroffen werden muss -
 *  "" wenn es keines gibt (dann wird noch gestellt).
 *
 *  Rein und ohne Abhaengigkeit, deshalb direkt testbar. Bewusst KEINE
 *  Checkout-Tabelle mehr: Die beantwortet "wie komme ich von 170 auf 0",
 *  gefragt ist aber "worauf zielt der naechste Dart". Bei 170 ist die
 *  Antwort T20 - und auf ein Triple zoomt hier niemand.
 *
 *    2 <= Rest <= 40, gerade  ->  "D" + Rest/2      (D1 ... D20)
 *    Rest === 50              ->  "BULLSEYE"        (s. Modulkopf (2))
 *    sonst                    ->  ""
 *
 *  Bull (25) fehlt absichtlich: Ein Leg endet nur auf Doppel oder
 *  Bullseye, ein Rest von 25 ist also kein Ein-Dart-Finish. */
function direktesDoppel(rest) {
  const zahl = Number(rest);
  if (!Number.isFinite(zahl)) return "";
  if (zahl === 50) return "BULLSEYE";
  if (zahl >= 2 && zahl <= 40 && zahl % 2 === 0) return "D" + zahl / 2;
  return "";
}

/** Szene zu einem Zielfeld: Bereichsszene, sonst die allgemeine. */
function szeneFuerZiel(ziel, conf, bereichVon) {
  if (!conf.bereicheAktiv) return conf.szeneCheckout;
  const bereich = bereichVon(ziel);
  const szenen = {
    oben: conf.szeneOben,
    rechts: conf.szeneRechts,
    unten: conf.szeneUnten,
    links: conf.szeneLinks,
    mitte: conf.szeneMitte,
  };
  // Unbekannter Bereich oder leerer Szenenname: lieber die allgemeine
  // Checkout-Szene als ein Wechsel ins Nichts (OBS wuerde die Anfrage
  // mit "Szene gibt es nicht" quittieren und das Bild stehen lassen).
  return szenen[bereich] || conf.szeneCheckout;
}

function gewuenschteSzene(conf) {
  // Nur wenn das 501-Spiel sichtbar ist - sonst Standardszene.
  const screen = document.getElementById("game-501-screen");
  const sichtbar = screen && screen.style.display !== "none";
  if (!sichtbar) return conf.szeneStandard;

  const bereichVon =
    typeof window.boardBereich === "function" ? window.boardBereich : () => "";

  // Nur der Rest des Spielers, der vor DIESER Kamera wirft (Modulkopf (1)).
  // Fehlt die Auskunft, bleibt es bei der Standardszene - lieber kein Zoom
  // als der Zoom auf das Board von jemand anderem.
  const rest =
    typeof window.eigenerRest501 === "function" ? window.eigenerRest501() : null;

  const ziel = direktesDoppel(rest);
  return ziel ? szeneFuerZiel(ziel, conf, bereichVon) : conf.szeneStandard;
}

async function obsTick() {
  const conf = obsEinstellungen();
  if (!conf.enabled) return;
  if (!obsZustand.verbunden) {
    // Verbindungsaufbau stoesst der Takt an; die Wartezeiten drosseln.
    if (!obsZustand.wiederholTimer && !obsZustand.verbindet) verbindeObs();
    return;
  }

  const szene = gewuenschteSzene(conf);
  if (!szene || szene === obsZustand.aktuelleSzene) return;
  try {
    await obsZustand.obs.call("SetCurrentProgramScene", { sceneName: szene });
    obsZustand.aktuelleSzene = szene;
  } catch (error) {
    // Szene existiert nicht o. ae.: einmal je Wechselversuch loggen,
    // nicht je Takt - deshalb merken wir uns die Szene trotzdem.
    console.warn(`[obs] Szenenwechsel zu "${szene}" fehlgeschlagen:`, error?.message || error);
    obsZustand.aktuelleSzene = szene;
  }
}

function starteObsTakt() {
  if (obsZustand.taktTimer || typeof window === "undefined") return;
  if (!obsEinstellungen().enabled) return;
  obsZustand.taktTimer = setInterval(obsTick, TAKT_MS);
}

// ── Einstellungsseite (einstellungen.html) ────────────────────────────────

function fuelleObsFormular() {
  const conf = obsEinstellungen();
  const setze = (id, wert) => {
    const el = document.getElementById(id);
    if (el) {
      if (el.type === "checkbox") el.checked = Boolean(wert);
      else el.value = wert;
    }
  };
  setze("obs-enabled", conf.enabled);
  setze("obs-port", conf.port);
  setze("obs-password", conf.password);
  setze("obs-szene-checkout", conf.szeneCheckout);
  setze("obs-szene-standard", conf.szeneStandard);
  setze("obs-bereiche", conf.bereicheAktiv);
  setze("obs-szene-oben", conf.szeneOben);
  setze("obs-szene-rechts", conf.szeneRechts);
  setze("obs-szene-unten", conf.szeneUnten);
  setze("obs-szene-links", conf.szeneLinks);
  setze("obs-szene-mitte", conf.szeneMitte);
}

function speichereObsFormular() {
  const lies = (id) => document.getElementById(id);
  speichereObsEinstellungen({
    enabled: Boolean(lies("obs-enabled")?.checked),
    port: parseInt(lies("obs-port")?.value, 10) || 4455,
    password: lies("obs-password")?.value || "",
    szeneCheckout: lies("obs-szene-checkout")?.value.trim() || "Checkout",
    szeneStandard: lies("obs-szene-standard")?.value.trim() || "Standard",
    bereicheAktiv: Boolean(lies("obs-bereiche")?.checked),
    szeneOben: lies("obs-szene-oben")?.value.trim() || "",
    szeneRechts: lies("obs-szene-rechts")?.value.trim() || "",
    szeneUnten: lies("obs-szene-unten")?.value.trim() || "",
    szeneLinks: lies("obs-szene-links")?.value.trim() || "",
    szeneMitte: lies("obs-szene-mitte")?.value.trim() || "",
  });
  window.showToast?.(t("js.obs.001"), "success");
}

// Beim Laden der App: Takt nur starten, wenn eingeschaltet - fuer alle
// anderen laeuft hier exakt nichts.
if (typeof window !== "undefined") {
  starteObsTakt();
}

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler der Einstellungsseite und die
// Konsole (Fehlersuche: obsSteuerung.status()) greifen darauf zu.
// ---------------------------------------------------------------
const obsSteuerung = {
  einstellungen: obsEinstellungen,
  speichern: speichereObsEinstellungen,
  verbinde: verbindeObs,
  trenne: trenneObs,
  status: () => ({
    verbunden: obsZustand.verbunden,
    szene: obsZustand.aktuelleSzene,
  }),
};

Object.assign(window, {
  obsSteuerung,
  fuelleObsFormular,
  speichereObsFormular,
});

export {
  direktesDoppel,
  szeneFuerZiel,
  gewuenschteSzene,
  obsEinstellungen,
  speichereObsEinstellungen,
};
